import PropTypes from 'prop-types'
import { useMemo } from 'react'
import { Modal } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import './style.scss'

import CustomDataTable from 'general/components/CustomDataTable'
import { TYPE_INVOICE_EXCEL } from 'general/constants/AppConstants'
import { useAppSelector } from 'hooks/useRedux'
import { formatNumberWithCommas } from 'general/utils/Utils'
import SelectOptions from 'general/constants/SelectOptions'

ModalValidateUploadInvoiceExcel.prototype = {
  show: PropTypes.bool,
  setShow: PropTypes.func,
  content: PropTypes.string,
  handleConfirm: PropTypes.func,
  serials: PropTypes.array,
}

function ModalValidateUploadInvoiceExcel(props) {
  const dispatch = useDispatch()
  const { formatNumber } = useAppSelector((state) => state?.systemConfig)

  const { show, onHide, validateFileData, submit } = props

  // ==========================
  // 🔥 FIX LỖI RICHTEXT EXCELJS
  // ==========================
  const parseExcelValue = (value) => {
    if (value == null) return ''

    if (typeof value === 'object' && value.richText) {
      return value.richText.map((v) => v.text).join('')
    }

    if (typeof value === 'object') return ''

    return value
  }

  // ==========================
  // TABLE COLUMNS
  // ==========================
  const defaultColumns = useMemo(
    () => [
      {
        id: 'STT',
        name: 'STT',
        center: true,
        cell: (row) => (
          <p className="text-dark-75 m-0 text-center">{row?.numericalOrder}</p>
        ),
      },
      {
        id: 'rowExcel',
        name: 'cột excel',
        center: true,
        cell: (row) => (
          <p className="text-dark-75 m-0 text-center">
            {parseExcelValue(row?.rowExcel)}
          </p>
        ),
      },
      {
        id: 'status',
        name: 'Trạng thái kiểm tra',
        center: true,
        cell: (row) => (
          <div className="text-center">
            {row?.status ? (
              <div className="badge badge-light-success">Hợp lệ</div>
            ) : (
              <div className="badge badge-light-danger">Không hợp lệ</div>
            )}
          </div>
        ),
      },
      {
        id: 'nameProduct',
        name: 'Tên hàng hóa/dịch vụ',
        center: true,
        cell: (row) => (
          <p className="text-dark-75 m-0">
            {parseExcelValue(row?.nameProduct)}
          </p>
        ),
      },
      {
        id: 'paymentMethod',
        name: 'Hình thức thanh toán',
        center: true,
        cell: (row) => (
          <p className="text-dark-75 m-0">
            {row?.paymentMethod && (
              <>
                {SelectOptions.paymentMethod.some(
                  (item) => item.label === row?.paymentMethod,
                ) ? (
                  <div>{row?.paymentMethod}</div>
                ) : (
                  <div className="badge badge-light-danger">
                    {row?.paymentMethod}
                  </div>
                )}
              </>
            )}
          </p>
        ),
      },
      {
        id: 'quantity',
        name: 'Số lượng',
        center: true,
        cell: (row) =>
          formatNumberWithCommas(
            Number(parseExcelValue(row?.quantity)),
            formatNumber?.quantity,
          ),
      },
      {
        id: 'unitPrice',
        name: 'Đơn giá',
        center: true,
        cell: (row) =>
          formatNumberWithCommas(
            Number(parseExcelValue(row?.unitPrice)),
            !['VNĐ', 'VND'].includes(row?.currency)
              ? formatNumber.currencyUnitPrice
              : formatNumber.unitPrice,
          ),
      },
      {
        id: 'discount',
        name: 'Tiền chiết khấu',
        center: true,
        cell: (row) =>
          formatNumberWithCommas(
            Number(parseExcelValue(row?.discount)),
            !['VNĐ', 'VND'].includes(row?.currency)
              ? formatNumber.foreignCurrency
              : formatNumber.currencyExchange,
          ),
      },
      {
        id: 'total',
        name: 'Thành tiền',
        center: true,
        cell: (row) => (
          <span style={row?.status ? {} : { color: '#ee2334' }}>
            {formatNumberWithCommas(
              Number(parseExcelValue(row?.total)),
              !['VNĐ', 'VND'].includes(row?.currency)
                ? formatNumber.foreignCurrency
                : formatNumber.currencyExchange,
            )}
          </span>
        ),
      },
      {
        id: 'totalselfnature',
        name: 'Thành tiền hệ thống tự tính',
        center: true,
        cell: (row) =>
          formatNumberWithCommas(
            Number(parseExcelValue(row?.totalselfnature)),
            !['VNĐ', 'VND'].includes(row?.currency)
              ? formatNumber.foreignCurrency
              : formatNumber.currencyExchange,
          ),
      },
    ],
    [formatNumber],
  )

  const witdhAllTable = 750

  function getDivWidthByKey(dataObj, totalWidth, targetKey) {
    if (!dataObj || typeof dataObj !== 'object') return '0px'

    const validCount = Object.values(dataObj).filter(
      (v) => Array.isArray(v) && v.length > 0,
    ).length

    if (validCount === 0) return '0px'

    const valueOfKey = dataObj[targetKey]
    if (!Array.isArray(valueOfKey) || valueOfKey.length === 0) return '0px'

    return `${totalWidth / validCount}px`
  }

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      className="ModalValidateUploadInvoiceExcel"
    >
      <Modal.Header closeButton>
        <Modal.Title>Bảng kiểm tra update excel</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {TYPE_INVOICE_EXCEL.map((item) =>
          validateFileData?.[item.value]?.length > 0 ? (
            <div key={item.value} style={{ marginBottom: 20 }}>
              <span style={{ color: '#5180fb', fontSize: 16, fontWeight: 600 }}>
                Sheet {item.label}
              </span>

              <CustomDataTable
                columns={defaultColumns}
                dataSource={validateFileData[item.value]}
                isClickable
                scrollY={getDivWidthByKey(
                  validateFileData,
                  witdhAllTable,
                  item.value,
                )}
              />
            </div>
          ) : null,
        )}
      </Modal.Body>

      <Modal.Footer>
        <button className="btn btn-success px-8 mr-4" onClick={submit}>
          Tiếp tục tải lên
        </button>
        <button className="btn btn-outline-secondary px-8" onClick={onHide}>
          Đóng
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export default ModalValidateUploadInvoiceExcel
